import { useEffect, useState } from 'react';
import { getRexySocket } from '../hooks/useRexySocket';
import { subscribeMackCalculatorChanges } from './mackCalculatorNotifications';
import { subscribeMackInputsChanges } from './mackInputsNotifications';

// Reuse each Calculator surface's existing GET and decoder. A late response cannot
// overwrite a newer read or cross an owner-session boundary. No source operation runs here.
export function useCalculatorRetainedRead<T>(reader: (token?: string | null) => Promise<T>, token?: string | null) {
  const [value, setValue] = useState<T | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    let generation = 0;
    setValue(null); setError(false);
    const reload = async () => {
      const expected = ++generation;
      try {
        const next = await reader(token);
        if (active && expected === generation) { setValue(next); setError(false); }
      } catch {
        if (active && expected === generation) setError(true);
      }
    };
    const socket = getRexySocket();
    // Calculator reuses retained Inputs evidence. Inputs owns the single reconnect
    // read; both notice families keep their existing stable-identity deduplication.
    const stopInputs = subscribeMackInputsChanges(socket, () => { void reload(); });
    const stop = subscribeMackCalculatorChanges(socket, () => { void reload(); }, { reconnect: false });
    void reload();
    return () => { active = false; stopInputs(); stop(); };
  }, [reader, token]);
  return { value, error };
}
